import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './en.json';
import deTranslations from './de.json';
import frTranslations from './fr.json';
import itTranslations from './it.json';
import ptTranslations from './pt.json';
import esTranslations from './es.json';

const resources = {
  en: {
    translation: enTranslations
  },
  de: {
    translation: deTranslations
  },
  fr: {
    translation: frTranslations
  },
  it: {
    translation: itTranslations
  },
  pt: {
    translation: ptTranslations
  },
  es: {
    translation: esTranslations
  }
};

// Get initial language from localStorage or default to 'en'
const initialLanguage = localStorage.getItem('lang') || 'en';

i18n.use(initReactI18next).init({
  lng: initialLanguage,
  fallbackLng: 'en',
  resources,
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
